import { useIntl } from "react-intl";
import "./ErrorsList.scss";

interface OnlyIdProps {
  id: string | string[];
  value?: never;
}

interface OnlyValueProps {
  id?: never;
  value: string | string[];
}

type ErrorsListProps = OnlyIdProps | OnlyValueProps;

export default function ErrorsList(props: ErrorsListProps) {

  const { formatMessage } = useIntl();
  const items: string[] = [];

  if ("value" in props && props.value) {
    if (Array.isArray(props.value)) {
      props.value.forEach((val) => items.push(val));
    } else {
      items.push(props.value);
    }
  } else if ("id" in props) {
    if (Array.isArray(props.id)) {
      props.id.forEach((id) => items.push(formatMessage({ id })));
    } else {
      items.push(formatMessage({ id: props.id }));
    }
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <ul className="errors-list">
      {items.map((error, i) => (
        <li key={i} className="errors-list__item">
          {error}
        </li>
      ))}
    </ul>
  );
}